import {
  getInt32,
  getObject,
} from "@surya-digital/leo-ts-types";
import { ProjectSortOrder } from "./projectSortOrder";


export namespace GetActiveSpocProjectsSortOrderEnums {
  /* eslint-disable @typescript-eslint/no-shadow */
  export namespace ColumnName {
    export enum ColumnName {
      PROJECT_NAME = "PROJECT_NAME",
      CREATED_ON = "CREATED_ON",
      LAST_MODIFIED = "LAST_MODIFIED",
    }
  
    export interface ColumnNameDTO {
      case: string;
    }
  
    export const fromDTO = (dto: ColumnNameDTO): ColumnName => {
      if (dto === undefined || dto === null) {
        throw new InvalidGetActiveSpocProjectsSortOrderColumnNameError(
          `Invalid DTO ${dto} provided for ColumnName.ColumnName`
        );
      }
      switch (dto.case) {
        case "PROJECT_NAME":
          return ColumnName.PROJECT_NAME;
        case "CREATED_ON":
          return ColumnName.CREATED_ON;
        case "LAST_MODIFIED":
          return ColumnName.LAST_MODIFIED;
        default:
          throw new InvalidGetActiveSpocProjectsSortOrderColumnNameError(
            `Case ${dto.case} is not valid case of ColumnName.ColumnName`
          );
      }
    };
  
    export const toDTO = (columnName: ColumnName): ColumnNameDTO => {
      const enumDTO = {
        case: ColumnName[columnName],
      };
      return enumDTO;
    };
  }
  
}
export interface GetActiveSpocProjectsSortOrderDTO {
  sortIndex: number;
  columnName: GetActiveSpocProjectsSortOrderEnums.ColumnName.ColumnNameDTO;
  order: ProjectSortOrder.ProjectSortOrderDTO;
}

export class GetActiveSpocProjectsSortOrder {
  readonly isGetActiveSpocProjectsSortOrderGetActiveSpocProjectsSortOrder: boolean = true;

  readonly sortIndex: number;
  readonly columnName: GetActiveSpocProjectsSortOrderEnums.ColumnName.ColumnName;
  readonly order: ProjectSortOrder.ProjectSortOrder;


  constructor(
  sortIndex: number, 
  columnName: GetActiveSpocProjectsSortOrderEnums.ColumnName.ColumnName, 
  order: ProjectSortOrder.ProjectSortOrder
  ) {
    this.sortIndex = sortIndex;
    this.columnName = columnName;
    this.order = order;
  }

  static fromDTO(dto: GetActiveSpocProjectsSortOrderDTO): GetActiveSpocProjectsSortOrder {
    const sortIndex = getInt32(dto, "sortIndex", InvalidGetActiveSpocProjectsSortOrderSortIndexError);
    const columnName = GetActiveSpocProjectsSortOrderEnums.ColumnName.fromDTO(getObject(dto, "columnName", InvalidGetActiveSpocProjectsSortOrderColumnNameError));
    const order = ProjectSortOrder.fromDTO(getObject(dto, "order", InvalidGetActiveSpocProjectsSortOrderOrderError));
    return new GetActiveSpocProjectsSortOrder(
      sortIndex,
      columnName,
      order
    );
  }

  toDTO(): GetActiveSpocProjectsSortOrderDTO {
    const dto: GetActiveSpocProjectsSortOrderDTO = {
        sortIndex: this.sortIndex,
        columnName: GetActiveSpocProjectsSortOrderEnums.ColumnName.toDTO(this.columnName),
        order: ProjectSortOrder.toDTO(this.order)
    };
    return dto;
  }
  }

GetActiveSpocProjectsSortOrder.prototype.toString = function toString(): string {
  return `GetActiveSpocProjectsSortOrder(sortIndex='${this.sortIndex}',columnName='${this.columnName}',order='${this.order}')`;
};

export class InvalidGetActiveSpocProjectsSortOrderError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetActiveSpocProjectsSortOrderError";
  }
}
export class InvalidGetActiveSpocProjectsSortOrderSortIndexError extends InvalidGetActiveSpocProjectsSortOrderError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetActiveSpocProjectsSortOrderSortIndexError";
  }
}

export class InvalidGetActiveSpocProjectsSortOrderColumnNameError extends InvalidGetActiveSpocProjectsSortOrderError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetActiveSpocProjectsSortOrderColumnNameError";
  }
}

export class InvalidGetActiveSpocProjectsSortOrderColumnNameProjectNameError extends InvalidGetActiveSpocProjectsSortOrderColumnNameError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetActiveSpocProjectsSortOrderColumnNameProjectNameError";
  }
}

export class InvalidGetActiveSpocProjectsSortOrderColumnNameCreatedOnError extends InvalidGetActiveSpocProjectsSortOrderColumnNameError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetActiveSpocProjectsSortOrderColumnNameCreatedOnError";
  }
}

export class InvalidGetActiveSpocProjectsSortOrderColumnNameLastModifiedError extends InvalidGetActiveSpocProjectsSortOrderColumnNameError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetActiveSpocProjectsSortOrderColumnNameLastModifiedError";
  }
}

export class InvalidGetActiveSpocProjectsSortOrderOrderError extends InvalidGetActiveSpocProjectsSortOrderError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetActiveSpocProjectsSortOrderOrderError";
  }
}
